import React, { useState } from 'react';
import '../styles/sculptd-theme.css';

// import { HomeDashboardPanel } from '../components/exercise-app/HomeDashboardPanel';
// import { OnboardingPanel } from '../components/exercise-app/OnboardingPanel';
import WorkoutPlayerPanel from '../components/exercise-app/WorkoutPlayerPanel';
import ExerciseLibraryPanel from '../components/exercise-app/ExerciseLibraryPanel';
import { WorkoutRecordingPanel } from '../components/exercise-app/WorkoutRecordingPanel';
import { CommunityPanel } from '../components/exercise-app/CommunityPanel';
import SocialMediaPanel from '../components/exercise-app/SocialMediaPanel';
import HealthDataPanel from '../components/exercise-app/HealthDataPanel';
import { PhotoProgressPanel } from '../components/exercise-app/PhotoProgressPanel';
// import { MotivationalPanel } from '../components/exercise-app/MotivationalPanel';
import { SomaChatPanel } from '../components/exercise-app/SomaChatPanel';
import GamificationPanel from '../components/exercise-app/GamificationPanel';
import AdminDashboardPanel from '../components/exercise-app/AdminDashboardPanel';
import { DeviceIntegrationPanel } from '../components/exercise-app/DeviceIntegrationPanel';
import { WearableVerificationPlugin } from '../components/exercise-app/WearableVerificationPlugin';
import { RecoveryVerificationPlugin } from '../components/exercise-app/RecoveryVerificationPlugin';
import WeightManagementPanel from '../components/exercise-app/WeightManagementPanel';
import StorePanel from '../components/exercise-app/StorePanel';

const FitnessDesktop: React.FC = () => {
  const [activeComponent, setActiveComponent] = useState<string>('workout-player');

  const components = [
    // { id: 'dashboard', name: 'Home Dashboard', component: HomeDashboardPanel },
    // { id: 'onboarding', name: 'Onboarding', component: OnboardingPanel },
    { id: 'workout-player', name: 'Workout Player', component: WorkoutPlayerPanel },
    { id: 'exercise-library', name: 'Exercise Library', component: ExerciseLibraryPanel },
    { id: 'workout-recording', name: 'Workout Recording', component: WorkoutRecordingPanel },
    { id: 'community', name: 'Community', component: CommunityPanel },
    { id: 'social-media', name: 'Social Media', component: SocialMediaPanel },
    { id: 'health-data', name: 'Health Data', component: HealthDataPanel },
    { id: 'weight-management', name: 'Weight Management', component: WeightManagementPanel },
    { id: 'photo-progress', name: 'Photo Progress', component: PhotoProgressPanel },
    // { id: 'motivational', name: 'Motivational', component: MotivationalPanel },
    { id: 'soma-chat', name: 'Coach Chat', component: SomaChatPanel },
    { id: 'gamification', name: 'Awards', component: GamificationPanel },
    { id: 'admin-dashboard', name: 'Admin Dashboard', component: AdminDashboardPanel },
    { id: 'store', name: 'Store', component: StorePanel },
    { id: 'device-integration', name: 'Device Integration', component: DeviceIntegrationPanel },
    { id: 'wearable-verification', name: 'Wearable Verification', component: WearableVerificationPlugin },
    { id: 'recovery-verification', name: 'Recovery Verification', component: RecoveryVerificationPlugin },
  ];

  const renderActiveComponent = () => {
    const activeComp = components.find(comp => comp.id === activeComponent);
    if (!activeComp) return null;

    const Component = activeComp.component;
    return (
      <div className="h-full">
        <Component />
      </div>
    );
  };

  return (
    <div className="min-h-screen sculptd-component" style={{ background: 'var(--color-background)' }}>
      <div className="sculptd-card border-0 rounded-none shadow-sm border-b">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex justify-start items-center h-16">
            <div className="flex items-center">
              <img 
                src="/assets/sculptd-logo.png" 
                alt="SCULPTD" 
                className="h-16 w-auto"
                style={{ 
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex h-screen">
        <div className="w-64 sculptd-card border-0 rounded-none shadow-lg border-r" style={{ justifyContent: 'flex-start' }}>
          <div className="px-4 pt-4 pb-4 h-full overflow-y-auto">
            <nav className="space-y-1">
              {components.map((comp) => (
                <button
                  key={comp.id}
                  onClick={() => setActiveComponent(comp.id)}
                  className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 hover:bg-opacity-10"
                  style={{
                    background: activeComponent === comp.id 
                      ? 'var(--gradient-primary)' 
                      : 'transparent',
                    color: activeComponent === comp.id 
                      ? 'var(--color-white)' 
                      : 'var(--color-text-muted)'
                  }}
                  onMouseEnter={(e) => {
                    if (activeComponent !== comp.id) {
                      (e.target as HTMLElement).style.background = 'rgba(58, 175, 169, 0.1)';
                      (e.target as HTMLElement).style.color = 'var(--color-text)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeComponent !== comp.id) {
                      (e.target as HTMLElement).style.background = 'transparent';
                      (e.target as HTMLElement).style.color = 'var(--color-text-muted)';
                    }
                  }}
                >
                  {comp.name}
                </button>
              ))}
            </nav>
          </div>
        </div>

        <div className="flex-1 overflow-hidden">
          <div className="h-full p-6">
            <div className="sculptd-card h-full overflow-hidden">
              <div className="h-full overflow-auto">
                {renderActiveComponent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FitnessDesktop;
